<template>
	<div>
		<CHead :oHead="Head"></CHead>
		<div class="row mt-2">
			<div class="col-md-12 col-lg-12">
				<div class="card">
					<div class="card-body">
						<!-- FILTROS -->
						<CLoader :pConfigLoad="ConfigLoad">
							<template slot="BodyFormLoad">
								<div class="row">
									<div class="col-lg-12">
										<form class="form-inline justify-content-end">
											<label class="mr-1">Año</label>
											<select @change="SetIndexAnio()" :disabled="Disabled" v-model="Anio" class="form-control mr-2">
												<option v-for="(item, index) in ListaAnios" :key="index" :value="item">{{ item }}</option>
											</select>

											<label class="mr-1">Mes</label>
											<select class="form-control mr-2" :disabled="Disabled" v-model="Mes">
												<option :value="0">Enero</option>
												<option :value="1">Febrero</option>
												<option :value="2">Marzo</option>
												<option :value="3">Abril</option>
												<option :value="4">Mayo</option>
												<option :value="5">Junio</option>
												<option :value="6">Julio</option>
												<option :value="7">Agosto</option>
												<option :value="8">Septiembre</option>
												<option :value="9">Octubre</option>
												<option :value="10">Noviembre</option>
												<option :value="11">Diciembre</option>
											</select>

											<button @click="Guardar" :disabled="Disabled" type="button" class="btn btn-bradcrumb btn-01 save mt-1">
												<i v-show="Disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Guardar
											</button>
											<button @click="AgregarFila" type="button" class="btn btn-bradcrumb btn-pink mr-2 mt-1">
												<i class="fa fa-plus-circle"></i> Agregar Fila
											</button>
										</form>
										<hr/>
									</div>
								</div>
								<!-- CONTENIDO -->
								<div class="row">
									<div class="col-lg-12">
										<div class="table-finanzas mt-4">
											<table class="table-fin-spendplan">
												<thead>
													<tr>
														<th class="w-01 text-center">Personal</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Departamento</th>
														<th class="text-center">Cuenta</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Frecuencia</th>
														<th style="min-width:50px;max-width:52px"></th>
														<th class="text-center" style="min-width:150px;max-width:152px">Sueldo Base</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Horas Extra</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Comisiones y Bonos</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Descuentos</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Nomina</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Obligaciones de Ley</th>
														<th class="text-center" style="min-width:150px;max-width:152px">Beneficios</th>
														<th style="min-width:50px;max-width:52px"></th>
													</tr>
												</thead>
												<tbody v-if="ArrayDatos.length>0">
													<tr v-for="(item,index) in ArrayDatos[IndexAnio][Mes]" :key="index">
														<td class="w-01">
															<select v-if="GetVendedorBorrado(item.IdUsuario)===false" @change="SetPersonal(index,item.IdProvisional)" v-model="item.IdUsuario" class="form-control">
																<option value="">-Personal-</option>
																<option v-for="(item2,index2) in ListaVendedores" :value="item2.IdUsuario" :key="index2">{{item2.NombreAdmin}}</option>
															</select>
															<select v-if="GetVendedorBorrado(item.IdUsuario)===true" @change="SetPersonal(index,item.IdProvisional)" v-model="item.IdUsuario" class="form-control" disabled>
																<option value="">-Personal-</option>
																<option v-for="(item2,index2) in ListaVendedoresTodos" :value="item2.IdUsuario" :key="index2">{{item2.NombreAdmin}}</option>
															</select>
														</td>
														<td style="min-width:150px;max-width:152px">
															<select :disabled="item.IdUsuario==''" @change="GetCuentas(index,item.IdProvisional)" v-model="item.TipoDepartamento" class="form-control">
																<option value="">-Departamento-</option>
																<option v-for="(item4,index4) in item.ListaDepartamentos" :value="item4.Id" :key="index4">{{item4.Label}}</option>
																<!-- <option value="1">G&A</option>
																<option value="2">Ventas</option>
																<option value="3">Burden</option>
																<option value="4">MO</option> -->
															</select>
														</td>
														<td>
															<select :disabled="item.IdUsuario==''" @change="SeleccionarCuenta(index,item.IdProvisional)" v-model="item.IdCuenta" class="form-control">
																<option value="">N/A</option>
																<option v-for="(item3,index3) in item.ListaCuentas" :value="item3.id" :key="index3">{{item3.label}}</option>
															</select>
														</td>
														<td style="min-width:150px;max-width:152px">
															<select :disabled="item.IdUsuario==''" @change="SetFrecuencia(index,item.IdProvisional)" v-model="item.Frecuencia" class="form-control">
																<option value="">-Frecuencia-</option>
																<option value="1">Semanal</option>
																<option value="2">Quincenal</option>
																<option value="3">Mensual</option>
															</select>
														</td>
														<td style="min-width:50px;max-width:52px">
															<button v-show="item.Frecuencia!='' && item.IdUsuario!=''" @click="AbrirDetalles(item.Detalle,index,item.IdProvisional)" data-toggle="modal" :data-target="'#formdetalle'" class="btn btn-outline-secondary" style="border:0;font-size:20px !important" v-b-tooltip.hover.right title="Ver Detalles"><i style="" class="fa fa-plus-circle"></i></button>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.SueldoBase" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.HorasExtra" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Comisiones" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Descuentos" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Nomina" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Obligaciones" placeholder="$ 0"/>
														</td>
														<td style="min-width:150px;max-width:152px">
															<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Beneficios" placeholder="$ 0"/>
														</td>
														<td style="min-width:50px;max-width:52px">
															<button @click="BorrarDato(index,item.IdProvisional)" type="button" class="btn-icon-02"><i class="fa fa-trash"></i></button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</template>
						</CLoader>
						<!-- <div class="row">
							<div class="col-lg-12 d-flex justify-content-end">
								<button :disabled="Disabled" @click="Guardar()" type="button" class="btn btn-pink">
                                    <i v-show="Disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i> Realizar Prefactura
                                </button>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<Modal :Nombre="NombreModal" :NameModal="'formdetalle'" :size="'modal-size-65-vw'" :pEmitSeccion="'formdetalle'" :poBtnSave="oBtnSave">
        	<template slot="Form">
        	    <FormDetalle :pEmitSeccion="'formdetalle'"></FormDetalle>
        	</template>
    	</Modal>
	</div>	
</template>

<script>
import CLoader from "@/components/CLoader.vue";
import Modal from '@/components/Cmodal.vue';
import FormDetalle from './FormDetalle.vue';
export default {
	name:'NominaForm',
	components:{CLoader,Modal,FormDetalle},
	data() {
		return {
			Head:{
                Title:'Registro Nomina',
                BtnNewShow:false,
                BtnNewName:'Nuevo',
                isreturn:false,
                isModal:false,                 
                isEmit:false,
                Url:'nomina',
                ObjReturn:'',
            },
			oBtnSave:{
				EmitSeccion:"formdetalle",
				txtSave:"Confirmar",
				nombreModal:"formdetalle"
			},
			Anio:'',
			IndexAnio:0,
			Mes:0,
			ListaAnios:[],
			Disabled:false,
			ArrayDatos:[],
			ArrayDatosCopia:[],
			ListaVendedores:[],
			ListaVendedoresTodos:[],
			NombreModal:'',
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
			IdProvisional:1
		}
	},
	methods: {
		Guardar(){
			//VALIDACIONES
			// console.log(this.ArrayDatos);
			let Bnd=false;
			let Mensaje='';
			let Meses=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
			for (let i = 0; i < this.ArrayDatos.length; i++) {
				for (let j = 0; j < this.ArrayDatos[i].length; j++) {
					// if (i==2 && j==1) {
					// 	console.log(this.ArrayDatos[i][j]);
					// 	return false;	
					// }
					if (this.ArrayDatos[i][j].length>0) {
						// let Contador=1;
						for (let k = 0; k < this.ArrayDatos[i][j].length; k++) {
							if (Bnd==false) {
								if (this.ArrayDatos[i][j][k].IdUsuario=='') {
									Bnd=true;
									Mensaje='Falta seleccionar trabajadores en el mes '+Meses[j]+' del año '+this.ListaAnios[i];
								}
								if (this.ArrayDatos[i][j][k].TipoDepartamento=='') {
									Bnd=true;
									Mensaje='Falta seleccionar departamentos en el mes '+Meses[j]+' del año '+this.ListaAnios[i];
								}
								if (this.ArrayDatos[i][j][k].Frecuencia=='') {
									Bnd=true;
									Mensaje='Falta seleccionar la frecuencia en el mes '+Meses[j]+' del año '+this.ListaAnios[i];
								}
								// Contador++;
							}							
						}
					}					
				}
			}
			if (Bnd===true) {
				this.Disabled=false;
				this.$toast.warning(Mensaje);
				return false;
			}
			//FIN VALIDACIONES
			this.Disabled=true;
			let formData=new FormData();
			formData.append('ArrayDetalle',JSON.stringify(this.ArrayDatos));
			formData.append('ArrayDetalleCopia',JSON.stringify(this.ArrayDatosCopia));
			this.$http.post('nominausuario/post',formData).then((res)=>{
				this.$toast.success('Información Guardada');
				this.Disabled=false;
				this.$router.push({name:'historialnomina'});
			}).catch((err) => {
				this.Disabled=false;
			})
		},
		GetAnios(){
			this.$http.get("funciones/getanios", 
				{	
					params: {

					}
				}).then((res) => {
					this.Anio=res.data.AnioActual;
					this.Mes=parseInt(res.data.MesActual)-1;
					this.ListaAnios=res.data.ListaAnios;
					for (let index = 0; index < this.ListaAnios.length; index++) {
						this.ArrayDatos.push([]);
						for (let j = 0; j < 12; j++) {
							this.ArrayDatos[index].push([]);	
						}
					}
					this.SetIndexAnio();
					this.Recuperar();
				}).finally(()=>{
					// console.log(this.ArrayDatos);
				})
		},
		async Recuperar(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('nominausuario/recovery').then((res) => {
				this.ArrayDatos=res.data.data;
				this.ArrayDatosCopia=res.data.datacopy;
				// console.log(this.ArrayDatos);
				for (let i = 0; i < this.ArrayDatos.length; i++) {
					let IdUsuarios=new Map();
					for (let j = 0; j < this.ArrayDatos[i].length; j++) {
						for (let k = 0; k < this.ArrayDatos[i][j].length; k++) {
							if (!IdUsuarios.has(this.ArrayDatos[i][j][k].IdUsuario)) {
								IdUsuarios.set(this.ArrayDatos[i][j][k].IdUsuario,this.IdProvisional++);
							}
							this.ArrayDatos[i][j][k].IdProvisional=IdUsuarios.get(this.ArrayDatos[i][j][k].IdUsuario);

							for (let l = 0; l < this.ArrayDatos[i][j][k].Detalle.length; l++) {
								let Fecha=this.ArrayDatos[i][j][k].Detalle[l].Fecha.replace(/-/g, "\/");
								this.ArrayDatos[i][j][k].Detalle[l].Fecha=new Date(Fecha);	
							}
						}						
					}
				}
				// console.log(this.ArrayDatos);
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		GetVendedorBorrado(IdUsuario){
			if (IdUsuario!="") {
				let IndexUsuario=this.ListaVendedoresTodos.findIndex(value => value.IdUsuario==IdUsuario);
				// console.log(IdUsuario)
				if (IndexUsuario!=-1) {
					if(this.ListaVendedoresTodos[IndexUsuario].RegEstatus=='B'){
						return true;
					}
					else{
						return false;
					}
				}	
			}
			else{
				return false;
			}
		},
		async GetVendedor(){
			await this.$http.get('vendedores/get', {
                params: { Tecnicos:true },
            })
            .then((res) => {
				this.ListaVendedoresTodos=res.data.data.Vendedores;
				let Filtrado=res.data.data.Vendedores.filter((value) => {
					if (value.RegEstatus=='A') {
						return true;
					}
					else{
						return false;
					}
				});
                let Mapeado=Filtrado.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaVendedores=Mapeado;
            });
		},
		async GetCuentas(Index,IdProvisional=undefined){
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].ListaCuentas=[];
			for (let i = this.Mes; i < 12; i++) {
				if (typeof (IdProvisional)=='undefined') {
					let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
					if (IndexTrabajador!=-1) {
						// this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].IdCuenta=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdCuenta;
						this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].ListaCuentas=[];
						this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].TipoDepartamento=this.ArrayDatos[this.IndexAnio][this.Mes][Index].TipoDepartamento;
					}
				}
				else{
					let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
					if (IndexInsercion!=-1) {
						this.ArrayDatos[this.IndexAnio][i][IndexInsercion].ListaCuentas=[];
						this.ArrayDatos[this.IndexAnio][i][IndexInsercion].TipoDepartamento=this.ArrayDatos[this.IndexAnio][this.Mes][Index].TipoDepartamento;
					}
				}
				// if (typeof this.ArrayDatos[this.IndexAnio][i][Index]!=='undefined') {
				// 	this.ArrayDatos[this.IndexAnio][i][Index].ListaCuentas=[];
				// 	this.ArrayDatos[this.IndexAnio][i][Index].TipoDepartamento=this.ArrayDatos[this.IndexAnio][this.Mes][Index].TipoDepartamento;	
				// }
			}
			switch (this.ArrayDatos[this.IndexAnio][this.Mes][Index].TipoDepartamento) {
				case '1':
					await this.$http.get('costoga/get',{params:{
						Anio:this.Anio
					}}).then((res)=>{
						this.ArrayDatos[this.IndexAnio][this.Mes][Index].ListaCuentas=res.data.data.lista.map((element) => {
							return {id:element.IdCostoGA,label:element.NumeroCuenta + " - " + element.Descripcion}
						});
						for (let i = this.Mes; i < 12; i++) {
							if (this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdNominaUsuario>0) {
								let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
								if (IndexTrabajador!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].ListaCuentas=res.data.data.lista.map((element) => {
										return {id:element.IdCostoGA,label:element.NumeroCuenta + " - " + element.Descripcion}
									});
								}
							}
							else{
								let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
								if (IndexInsercion!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexInsercion].ListaCuentas=res.data.data.lista.map((element) => {
										return {id:element.IdCostoGA,label:element.NumeroCuenta + " - " + element.Descripcion}
									});
								}
							}
							// if(typeof this.ArrayDatos[this.IndexAnio][i][Index]!=='undefined'){
							// 	this.ArrayDatos[this.IndexAnio][i][Index].ListaCuentas=res.data.data.lista.map((element) => {
							// 		return {id:element.IdCostoGA,label:element.NumeroCuenta + " - " + element.Descripcion}
							// 	});
							// }
						}
					});
					break;
				case '2':
					await this.$http.get('costoventas/getall',{params:{
						Anio:this.Anio
					}}).then((res)=>{
						this.ArrayDatos[this.IndexAnio][this.Mes][Index].ListaCuentas=res.data.data.listagastoctpp.map((element) => {
							return {id:element.IdGasto,label:element.NumCuenta + " - " + element.Gasto}
						});
						for (let i = this.Mes; i < 12; i++) {
							if (this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdNominaUsuario>0) {
								let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
								if (IndexTrabajador!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].ListaCuentas=res.data.data.listagastoctpp.map((element) => {
										return {id:element.IdGasto,label:element.NumCuenta + " - " + element.Gasto}
									});
								}
							}
							else{
								let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
								if (IndexInsercion!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexInsercion].ListaCuentas=res.data.data.listagastoctpp.map((element) => {
										return {id:element.IdGasto,label:element.NumCuenta + " - " + element.Gasto}
									});
								}
							}
							// if(typeof this.ArrayDatos[this.IndexAnio][i][Index]!=='undefined'){
							// 	this.ArrayDatos[this.IndexAnio][i][Index].ListaCuentas=res.data.data.listagastoctpp.map((element) => {
							// 		return {id:element.IdGasto,label:element.NumCuenta + " - " + element.Gasto}
							// 	});
							// }
						}
					});
					break;
				case '3':
					await this.$http.get('costodeptooper/get',{params:{
						Anio:this.Anio
					}}).then((res)=>{
						this.ArrayDatos[this.IndexAnio][this.Mes][Index].ListaCuentas=res.data.data.lista.map((element) => {
							return {id:element.IdCostoDeptoVenta,label:element.NumeroCuenta + " - " + element.Descripcion}
						});
						for (let i = this.Mes; i < 12; i++) {
							if (this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdNominaUsuario>0) {
								let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
								if (IndexTrabajador!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].ListaCuentas=res.data.data.lista.map((element) => {
										return {id:element.IdCostoDeptoVenta,label:element.NumeroCuenta + " - " + element.Descripcion}
									});
								}
							}
							else{
								let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
								if (IndexInsercion!=-1) {
									this.ArrayDatos[this.IndexAnio][i][IndexInsercion].ListaCuentas=res.data.data.lista.map((element) => {
										return {id:element.IdCostoDeptoVenta,label:element.NumeroCuenta + " - " + element.Descripcion}
									});
								}
							}
							// if(typeof this.ArrayDatos[this.IndexAnio][i][Index]!=='undefined'){
							// 	this.ArrayDatos[this.IndexAnio][i][Index].ListaCuentas=res.data.data.lista.map((element) => {
							// 		return {id:element.IdCostoDeptoVenta,label:element.NumeroCuenta + " - " + element.Descripcion}
							// 	});
							// }
						}
					});
					break;
				default:
					break;
			}
		},
		SeleccionarCuenta(Index,IdProvisional=null){
			for (let i = this.Mes; i < 12; i++) {
				if (typeof (IdProvisional)=='undefined') {
					let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
					if (IndexTrabajador!=-1) {
						this.ArrayDatos[this.IndexAnio][i][IndexTrabajador].IdCuenta=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdCuenta;
					}	
				}
				else{
					let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
					if (IndexInsercion!=-1) {
						this.ArrayDatos[this.IndexAnio][i][IndexInsercion].IdCuenta=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdCuenta;
					}
				}

				// if (typeof this.ArrayDatos[this.IndexAnio][i][Index]!=='undefined') {
				// 	this.ArrayDatos[this.IndexAnio][i][Index].IdCuenta=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdCuenta;	
				// }
			}
		},
		SetIndexAnio(){
			this.IndexAnio=this.ListaAnios.findIndex((value) => this.Anio==value);
		},
		AgregarFila(){
			let MaxArray=11;
			let ContadorActual=this.Mes;
			while (ContadorActual<=MaxArray) {
				this.ArrayDatos[this.IndexAnio][ContadorActual].push({
					IdNominaUsuario:0,
					IdUsuario:'',
					Mes:ContadorActual,
					Anio:this.Anio,
					TipoDepartamento:'',
					IdCuenta:'',
					Frecuencia:'',
					SueldoBase:0,
					HorasExtra:0,
					Comisiones:0,
					Descuentos:0,
					Nomina:0,
					Obligaciones:0,
					Beneficios:0,
					ListaDepartamentos:[{Id:'1',Label:'G&A'},{Id:'2',Label:'Ventas'},{Id:'3',Label:'Burden'},{Id:'4',Label:'MO'}],
					ListaDepartamentosCopia:[{Id:'1',Label:'G&A'},{Id:'2',Label:'Ventas'},{Id:'3',Label:'Burden'},{Id:'4',Label:'MO'}],
					ListaCuentas:[],
					Detalle:[],
					IdProvisional:this.IdProvisional
				});	
				// console.log(this.IdProvisional);
				ContadorActual++;
			}
			this.IdProvisional++;
		},
		SetPersonal(Index,IdProvisional=undefined){
			// console.log(this.ArrayDatos[this.IndexAnio]);
			let MaxArray=11;
			let ContadorActual=this.Mes;
			while (ContadorActual<=MaxArray) {
				// console.log(this.ArrayDatos[this.IndexAnio][ContadorActual][Index].IdProvisional);
				if (typeof (IdProvisional)!=='undefined') {
					let IndexArray=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
					if (IndexArray!=-1) {
						this.ArrayDatos[this.IndexAnio][ContadorActual][IndexArray].IdUsuario=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario;		
					}
				}
				else{
					let IndexInsercion=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][IndexArray].IdProvisional);
					if (IndexInsercion!=-1) {
						this.ArrayDatos[this.IndexAnio][ContadorActual][IndexInsercion].IdUsuario=this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario;
					}
					
				}
				ContadorActual++;
			} 
		},
		SetFrecuencia(IndexArray,IdProvisional=undefined){
			let MaxArray=11;
			let ContadorActual=this.Mes;
			while (ContadorActual<=MaxArray) {
				let Index=IndexArray;
				if (typeof (IdProvisional)=='undefined') {
					let IndexTrabajador=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][IndexArray].IdUsuario);
					if (IndexTrabajador!=-1) {
						Index=IndexTrabajador;
					}	
				}
				else{
					let IndexInsercion=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][IndexArray].IdProvisional);
					if (IndexInsercion!=-1) {
						Index=IndexInsercion;
					}
				}

				this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Detalle=[];
				this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Frecuencia=this.ArrayDatos[this.IndexAnio][this.Mes][IndexArray].Frecuencia;
				let Fecha=new Date(parseInt(this.Anio),ContadorActual,1);
				let FechaUltimo=new Date(parseInt(this.Anio),ContadorActual+1,0);
				switch (this.ArrayDatos[this.IndexAnio][this.Mes][IndexArray].Frecuencia) {
					case '1':
						let InicioMes=new Date(parseInt(this.Anio), ContadorActual, 1);
						let FinMes=new Date(parseInt(this.Anio), ContadorActual + 1, 0);
						let FechaSemana=new Date(InicioMes);
						let DiasDomingo=(7 - FechaSemana.getDay()) % 7;
						FechaSemana.setDate(FechaSemana.getDate() + DiasDomingo);
						while (FechaSemana<=FinMes) {
							this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Detalle.push({
								Fecha:new Date(FechaSemana),
								SueldoBase:'',
								HorasExtra:'',
								Comisiones:'',
								Descuentos:'',
								Total:'',
								Obligaciones:'',
								Beneficios:''
							});
							FechaSemana.setDate(FechaSemana.getDate() + 7);
						}
						// let Suma=Fecha.getDay()+FechaUltimo.getDate();
						// let Semanas=Math.ceil( Suma / 7);
						// let FechaSemana=new Date(parseInt(this.Anio),ContadorActual,1);
						// for (let j = 0; j < Semanas; j++) {
						// 	FechaSemana = new Date(FechaSemana.getTime());
        				// 	FechaSemana.setDate(FechaSemana.getDate() + 6);
						// 	this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Detalle.push({
						// 		Fecha:FechaSemana,
						// 		SueldoBase:'',
						// 		HorasExtra:'',
						// 		Comisiones:'',
						// 		Descuentos:'',
						// 		Total:'',
						// 		Obligaciones:'',
						// 		Beneficios:''
						// 	});
						// }
						break;
					case '2':
						let FechaQuincena=new Date(parseInt(this.Anio),ContadorActual,1);
						let Dias=14;
						for (let j = 0; j < 2; j++) {
							FechaQuincena = new Date(FechaQuincena.getTime());
        					FechaQuincena.setDate(FechaQuincena.getDate() + Dias);
							this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Detalle.push({
								Fecha:FechaQuincena,
								SueldoBase:'',
								HorasExtra:'',
								Comisiones:'',
								Descuentos:'',
								Total:'',
								Obligaciones:'',
								Beneficios:''
							});
							Dias++;
						}
						break;
					case '3':
						let FechaMes=new Date(parseInt(this.Anio),ContadorActual+1,0);
						this.ArrayDatos[this.IndexAnio][ContadorActual][Index].Detalle.push({
							Fecha:FechaMes,
							SueldoBase:'',
							HorasExtra:'',
							Comisiones:'',
							Descuentos:'',
							Total:'',
							Obligaciones:'',
							Beneficios:''
						});
						break;
					default:
						break;
				}
				ContadorActual++;
			}
			// console.log(this.ArrayDatos[this.IndexAnio][this.Mes]);
		},
		AbrirDetalles(item,index,IdProvisional=undefined){
			let i=this.ListaVendedores.findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][index].IdUsuario);
			this.NombreModal=this.ListaVendedores[i].NombreAdmin;
			this.bus.$emit('PassDetalles',item,index,IdProvisional);
		},
		GuardarDetalles(Detalle,Index,IdProvisional){
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].Detalle=Detalle;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].SueldoBase=0;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].HorasExtra=0;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].Comisiones=0;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].Descuentos=0;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].Nomina=0;
			this.ArrayDatos[this.IndexAnio][this.Mes][Index].Detalle.forEach((element) => {
				// this.ArrayDatos[this.IndexAnio][this.Mes][Index].SueldoBase=parseInt(this.ArrayDatos[this.IndexAnio][this.Mes][Index].SueldoBase);
				let SueldoBase=isNaN(parseInt(element.SueldoBase)) ? 0 : parseInt(element.SueldoBase);
				let HorasExtra=isNaN(parseInt(element.HorasExtra)) ? 0 : parseInt(element.HorasExtra);
				let Comisiones=isNaN(parseInt(element.Comisiones)) ? 0 : parseInt(element.Comisiones);
				let Descuentos=isNaN(parseInt(element.Descuentos)) ? 0 : parseInt(element.Descuentos);
				let Nomina=isNaN(parseInt(element.Total)) ? 0 : parseInt(element.Total);
				this.ArrayDatos[this.IndexAnio][this.Mes][Index].SueldoBase+=SueldoBase;
				this.ArrayDatos[this.IndexAnio][this.Mes][Index].HorasExtra+=HorasExtra;
				this.ArrayDatos[this.IndexAnio][this.Mes][Index].Comisiones+=Comisiones;
				this.ArrayDatos[this.IndexAnio][this.Mes][Index].Descuentos+=Descuentos;
				this.ArrayDatos[this.IndexAnio][this.Mes][Index].Nomina+=Nomina;
			});
			for (let i = this.Mes+1; i < 12; i++) {
				let IndexArray=0;
				if (typeof (IdProvisional)=='undefined') {
					let IndexTrabajador=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
					if (IndexTrabajador!=-1) {
						IndexArray=IndexTrabajador;
					}
					else{
						IndexArray=Index;
					}
				}
				else{
					let IndexInsercion=this.ArrayDatos[this.IndexAnio][i].findIndex((value) => value.IdProvisional==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdProvisional);
					if (IndexInsercion!=-1) {
						IndexArray=IndexInsercion;
					}
					else{
						IndexArray=Index;
					}
				}
				this.ArrayDatos[this.IndexAnio][i][IndexArray].SueldoBase=0;
				this.ArrayDatos[this.IndexAnio][i][IndexArray].Nomina=0;
				for (let j = 0; j < this.ArrayDatos[this.IndexAnio][this.Mes][Index].Detalle.length; j++) {
					// const element = array[j];
					if (this.ArrayDatos[this.IndexAnio][i][IndexArray].Detalle[j]!=undefined) {
						this.ArrayDatos[this.IndexAnio][i][IndexArray].Detalle[j].SueldoBase=this.ArrayDatos[this.IndexAnio][this.Mes][Index].Detalle[j].SueldoBase;
						this.ArrayDatos[this.IndexAnio][i][IndexArray].Detalle[j].Total=this.ArrayDatos[this.IndexAnio][this.Mes][Index].Detalle[j].SueldoBase;	
					}
				}
				this.ArrayDatos[this.IndexAnio][i][IndexArray].Detalle.forEach((element) => {
					let SueldoBase=isNaN(parseInt(element.SueldoBase)) ? 0 : parseInt(element.SueldoBase);
					let Nomina=isNaN(parseInt(element.Total)) ? 0 : parseInt(element.Total);
					this.ArrayDatos[this.IndexAnio][i][IndexArray].SueldoBase+=SueldoBase;
					this.ArrayDatos[this.IndexAnio][i][IndexArray].Nomina+=Nomina;
				});
			}	
		},
		BorrarDato(Index,IdProvisional=undefined){
			this.$swal({
				title: "Esta seguro que desea eliminar este dato?",
				text: "No se podra revertir esta acción",
				type: "warning",
				showCancelButton: true,
				confirmButtonText: "Si",
				cancelButtonText: "No, mantener",
				showCloseButton: true,
				showLoaderOnConfirm: true
			}).then((result)=>{
				if (result.value) {
					let MaxArray=11;
					let ContadorActual=this.Mes;
					while (ContadorActual<=MaxArray) {
						let IndexArray=0;
						if (typeof (IdProvisional)!=='undefined') {
							let IndexInsercion=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdProvisional==IdProvisional);
							if (IndexInsercion!=-1) {
								IndexArray=IndexInsercion;
							}
							else{
								IndexArray=Index;
							}
							this.ArrayDatos[this.IndexAnio][ContadorActual].splice(IndexArray,1);
						}
						else{
							let IndexTrabajador=this.ArrayDatos[this.IndexAnio][ContadorActual].findIndex((value) => value.IdUsuario==this.ArrayDatos[this.IndexAnio][this.Mes][Index].IdUsuario);
							if (IndexTrabajador!=-1) {
								IndexArray=IndexTrabajador;
							}
							else{
								IndexArray=Index;
							}
							this.ArrayDatos[this.IndexAnio][ContadorActual].splice(IndexArray,1);
						}
						// console.log(IndexArray);
						ContadorActual++;
					}
					// this.ArrayDatos[this.IndexAnio][this.Mes].splice(Index,1);
					// console.log(this.ArrayDatos);
					// console.log(this.ArrayDatosCopia);
					this.$toast.success('Información Eliminada');
				}
			})
			// console.log(this.IdProvisional);
		}
	},
	created() {
		this.GetAnios();
		this.GetVendedor();
		this.bus.$off('EnviarDetalle');
		this.bus.$on('EnviarDetalle',(Detalle,Index,IdProvisional)=>{
			this.GuardarDetalles(Detalle,Index,IdProvisional);
		})
	},
}
</script>

<style>

</style>
